import { FiChevronRight } from 'react-icons/fi';
import { MdKeyboardBackspace } from 'react-icons/md';
import styled from 'styled-components';

const Container = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  margin-bottom: 24px;

  a {
    font-size: 14px;
    font-weight: 600;
    line-height: 24px;
    letter-spacing: 0.2px;
    text-align: left;
    color: ${({ theme }) => theme.COLOR_PRIMARY};
    text-decoration: none;
  }
`;

const BreadcrumbItems = styled.div`
  display: flex;
  align-items: center;
`;

const ButtonsContainer = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
`;

const BackIcon = styled(MdKeyboardBackspace)`
  margin-right: 16px;
  color: ${({ theme }) => theme.COLOR_BLACK};
  cursor: pointer;
`;

const ChevronIcon = styled(FiChevronRight)`
  margin: 0 16px;
  color: ${({ theme }) => theme.COLOR_GREY4};
`;

const StyledBreadcrumb = {
  Container,
  BreadcrumbItems,
  ButtonsContainer,
  BackIcon,
  ChevronIcon,
};

export default StyledBreadcrumb;
